import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as r } from "react/jsx-runtime";
import { calculateRem as o, withVDSManager as t } from "@vds-core/utilities";
import n, { css as a } from "styled-components";
import { ColorTokens as i } from "@vds-tokens/color";
import { LayoutTokens as d } from "@vds-tokens/layout";
var l = d.space["3X"].value,
  s = d.space["4X"].value,
  c = d.space["6X"].value,
  m = d.space["8X"].value,
  p = function p(e, r) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    if (!e && void 0 === e) return t ? "".concat(o(1), " solid ").concat(i.elements.primary["on".concat(r)].value) : "".concat(o(1), " solid ").concat("dark" === r ? i.elements.lowcontrast.ondark.value : i.elements.lowcontrast.onlight.value);
    switch (e) {
      case "primary":
        return "".concat(o(1), " solid ").concat(i.elements.primary["on".concat(r)].value);
      case "secondary":
        return "".concat(o(1), " solid ").concat("dark" === r ? i.elements.lowcontrast.ondark.value : i.elements.lowcontrast.onlight.value);
      default:
        return "none";
    }
  },
  u = n.table.withConfig({
    displayName: "StyledTable",
    componentId: "VDS__sc-ag8xux-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  border-spacing: 0;\n  text-align: left;\n  width: 100%;\n  font-size: ", ";\n  padding-top: ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n\n  ", ";\n  ", "\n  &:focus {\n    outline: none;\n  }\n"])), o(14), o(18), function (_ref) {
    var e = _ref.$hideBottomPadding;
    return a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), e ? void 0 : o(d.space["8X"].value));
  }, function (_ref2) {
    var e = _ref2.$paddingHeader,
      r = _ref2.$paddingCells,
      o = _ref2.$striped;
    return a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    td {\n      padding: ", ";\n    }\n    th {\n      padding: ", ";\n    }\n  "])), r, e);
  }, function (_ref3) {
    var e = _ref3.$bottomLine,
      r = _ref3.surface;
    return a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    thead {\n      tr {\n        border-bottom: ", ";\n      }\n    }\n  "])), p(e, r, !0));
  }, function (_ref4) {
    var e = _ref4.$bottomLine,
      r = _ref4.surface,
      o = _ref4.$striped,
      t = _ref4.$stripePattern;
    return a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    tbody {\n      ", "\n    }\n  "])), o ? "tr {\n            ".concat(e ? "border-bottom: ".concat(p(e, r), ";") : "border-bottom: none;", "\n            &:nth-child(").concat(t, ") {\n              background-color: ").concat(r && i.background.secondary[r].value, ";\n            }\n          }") : "tr {\n            border-bottom: ".concat(p(e, r), ";\n          }"));
  }, function (_ref5) {
    var e = _ref5.surface,
      r = _ref5.$stripePattern;
    return "dark" === e && a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      td,\n      th {\n        color: ", ";\n      }\n\n      // Overriding tableHead bottomLine when surface is dark\n      .thead-primary-line-override {\n        tr {\n          border-color: ", " !important;\n        }\n      }\n      .thead-secondary-line-override {\n        tr {\n          border-color: ", " !important;\n        }\n      }\n      .thead-none-line-override {\n        tr {\n          border: none !important;\n        }\n      }\n\n      // Overriding boder-color color on any tableRow if bottomLine prop is passed\n      tbody {\n        .tr-primary-line-override {\n          border-color: ", " !important;\n        }\n        .tr-secondary-line-override {\n          border-color: ", " !important;\n        }\n        .tr-none-line-override {\n          border: none !important;\n        }\n      }\n      .tbody-striped-override {\n        tr:nth-child(", ") {\n          background-color: ", " !important;\n        }\n      }\n    "])), i.elements.primary.ondark.value, i.elements.primary.ondark.value, i.elements.lowcontrast.ondark.value, i.elements.primary.ondark.value, i.elements.lowcontrast.ondark.value, r, i.background.secondary.dark.value);
  }, function (_ref6) {
    var e = _ref6.$striped;
    return e && a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      thead {\n        tr {\n          border-bottom: none;\n        }\n      }\n    "])));
  });
var $ = t(function (t) {
  var n = t.striped,
    a = t.viewport,
    i = t.ariaLabel,
    d = t["aria-label"],
    p = t.children,
    _t$surface = t.surface,
    $ = _t$surface === void 0 ? "light" : _t$surface,
    b = t.bottomLine,
    _t$stripePattern = t.stripePattern,
    v = _t$stripePattern === void 0 ? "odd" : _t$stripePattern,
    f = t.padding,
    _t$hideBottomPadding = t.hideBottomPadding,
    g = _t$hideBottomPadding === void 0 ? !1 : _t$hideBottomPadding,
    h = e(t, ["striped", "viewport", "ariaLabel", "aria-label", "children", "surface", "bottomLine", "stripePattern", "padding", "hideBottomPadding"]);
  var y = i || d;
  return r(u, Object.assign({}, h, {
    surface: $,
    "aria-label": y,
    $paddingHeader: n && void 0 === f || "compact" === f ? "mobile" === a ? o(l, n ? l : c, l, n ? l : 0) : o(s, n ? s : m, s, n ? s : 0) : "mobile" === a ? o(c, n ? l : c, c, n ? l : 0) : o(m, n ? s : m, m, n ? s : 0),
    $paddingCells: n && void 0 === f || "compact" === f ? "mobile" === a ? o(l, n ? l : c, l, n ? l : 0) : o(s, n ? s : m, s, n ? s : 0) : "mobile" === a ? o(c, n ? l : c, c, n ? l : 0) : o(m, n ? s : m, m, n ? s : 0),
    $bottomLine: b,
    $stripePattern: v,
    $striped: n,
    padding: f,
    $hideBottomPadding: g,
    children: p
  }));
});
export { $ as default };